import { render } from "./Maintenance.vue?vue&type=template&id=6a08da7a"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"
script.render = render

export default script